<template>
  <Builder :settings="settings">
    <template #actions>
      <Actions />
    </template>
  </Builder>
</template>

<script
  lang="ts"
  setup
>
import { useQuery } from '@vue/apollo-composable';
import gql from 'graphql-tag';
import { computed, reactive, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import Builder from '@/modules/marketing/email/builder/index.vue';
import { useMarketingStore } from '../../../store';
import { useMarketingBuilderStore } from '../../../store/builder';
import Actions from './Actions.vue';

const builderStore = useMarketingBuilderStore();

const { t } = useI18n();

const allFiltersForGraphql = computed(() => {
  const { allFiltersForGraphql } = useMarketingStore();
  return allFiltersForGraphql;
});

const settings = reactive({
  title: t('marketing.email.intro.title'),
  description: t('marketing.email.intro.description'),
  sentDescription: t(
    'marketing.email.sections.when_it_should_be_sent_scheduled',
  ),
  receiveDescription: t(
    'marketing.email.sections.who_is_going_to_receive_it_info',
  ),
  showFilters: true,
  showSendTest: true,
  allowImageUpload: true,
});

const loading = ref(false);

const fetchFilteredCustomersCount = () => {
  loading.value = true;

  const { onResult } = useQuery(
    gql`
      query filteredCustomersCount($filters: [CustomerFilterInput!]!) {
        filteredCustomersCount(filters: $filters)
      }
    `,
    {
      filters: allFiltersForGraphql,
    },
  );

  onResult((value: any) => {
    builderStore.setFilteredCustomersCount(value.data.filteredCustomersCount);
    loading.value = false;
  });
};

fetchFilteredCustomersCount();

watch(loading, () => {
  builderStore.setLoadingCustomersCount(loading.value);
});

watch(allFiltersForGraphql, () => {
  fetchFilteredCustomersCount();
});
</script>
